import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/common/SEOHead';

const ROUTES = {
  ar: '/ar/remove-personal-data',
  sv: '/ta-bort-personuppgifter',
  en: '/en/remove-personal-data',
  fr: '/fr/supprimer-donnees-personnelles',
};

const LANG = {
  ar: { label: 'العربية', locale: 'ar-SE', dir: 'rtl' },
  sv: { label: 'Svenska', locale: 'sv-SE', dir: 'ltr' },
  en: { label: 'English', locale: 'en-SE', dir: 'ltr' },
  fr: { label: 'Français', locale: 'fr-SE', dir: 'ltr' },
};

const WHATSAPP_NUMBER = '46734877119';
const HELP_PRICE = 299;
const PROGRESS_KEY = 'startawebb-privacy-removal-progress-v2';
const GOOGLE_REMOVE_URL = 'https://support.google.com/websearch/contact/content_removal_form?hl=sv';

const SOURCES = [
  { key: 'ratsit', name: 'Ratsit', actionUrl: 'https://www.ratsit.se/tabort', result: 'remove' },
  { key: 'hitta', name: 'Hitta.se', actionUrl: 'https://www.hitta.se/kontakta-oss/ta-bort-kontaktsida', result: 'remove' },
  { key: 'eniro', name: 'Eniro', actionUrl: 'https://uppdatera.eniro.se/person', result: 'remove' },
  { key: 'mrkoll', name: 'MrKoll', actionUrl: 'https://mrkoll.se/om/ta-bort/', result: 'hide' },
  { key: 'merinfo', name: 'Merinfo', actionUrl: 'https://www.merinfo.se/ta-bort-mina-uppgifter', result: 'remove' },
  { key: 'birthday', name: 'Birthday.se', actionUrl: 'https://appen.minauppgifter.se/sites/xk9m2', result: 'remove' },
];

const COPY = {
  ar: {
    seoTitle: 'حذف معلوماتك الشخصية من مواقع الأشخاص في السويد | StartaWebb',
    seoDescription: 'روابط رسمية مباشرة لحذف أو إخفاء معلوماتك من Ratsit وHitta وEniro وMrKoll وMerinfo وBirthday، مع مساعدة اختيارية بالعربية.',
    badge: 'حذف البيانات الشخصية في السويد',
    title: 'احذف معلوماتك الشخصية من مواقع الأشخاص',
    intro: 'يمكنك تنفيذ الخطوات بنفسك مجانًا عبر الروابط الرسمية. وإذا أردت المساعدة، نراجع معك المواقع ونرشدك خطوة بخطوة.',
    freeBadge: 'الخيار المجاني',
    freeTitle: 'نفّذها بنفسك',
    freeText: 'كل روابط الحذف والإخفاء الرسمية تبقى متاحة لك مجانًا.',
    freeButton: 'ابدأ بالروابط المجانية',
    paidBadge: 'تريد المساعدة؟',
    paidTitle: 'نراجع المواقع معك',
    paidText: 'نساعدك في معرفة أين ما زالت معلوماتك ظاهرة، وما الخطوة الصحيحة في كل موقع.',
    paidButton: 'اطلب المساعدة عبر WhatsApp',
    trustText: 'لن نطلب منك مشاركة BankID أو كلمة مرور. أي تحقق شخصي تقوم به أنت بنفسك.',
    includesTitle: 'المساعدة تشمل',
    includes: ['مراجعة المواقع الرئيسية', 'تحديد الخطوة المناسبة لكل موقع', 'متابعة ما بقي ظاهرًا بعد التنفيذ'],
    directTitle: 'اختر الموقع',
    directText: 'استخدم الرابط الرسمي مجانًا، أو اطلب المساعدة لهذا الموقع فقط.',
    methodBankId: 'BankID',
    removeStatus: 'حذف',
    hideStatus: 'إخفاء',
    open: (name) => `حذف معلوماتي من ${name}`,
    openHide: (name) => `إخفاء معلوماتي من ${name}`,
    helpService: (name) => `ساعدني في ${name}`,
    markDone: 'تم',
    done: 'تم ✓',
    details: 'طريقة الحذف',
    guides: {
      ratsit: 'افتح صفحة الحذف، ثم عرّف نفسك عبر BankID واتبع التعليمات حتى النهاية.',
      hitta: 'ابحث عن صفحتك داخل Hitta، اختر النتيجة الصحيحة، ثم اضغط Ta bort وأكمل التحقق.',
      eniro: 'ابحث عن اسمك في Eniro، ادخل عبر BankID، ثم اختر إزالة أو إخفاء البيانات المتاحة.',
      mrkoll: 'ادخل عبر BankID ثم اختر إخفاء البيانات التي يسمح MrKoll بإخفائها.',
      merinfo: 'افتح صفحة الحذف في Merinfo، أكمل التحقق، ثم أكد إزالة ملفك.',
      birthday: 'افتح صفحة Birthday في MinaUppgifter، تحقق عبر BankID ثم أكد إزالة معلوماتك.',
    },
    warningTitle: 'إذا كان رقم هاتفك يعود للظهور',
    warningText: 'اطلب من شركة الاتصالات جعل رقمك غير متاح لخدمات الدليل، ثم أعد التحقق من المواقع بعد تحديث البيانات.',
    googleTitle: 'هل ما زال الرابط يظهر في Google؟',
    googleText: 'بعد حذف الصفحة من الموقع الأصلي، يمكنك طلب إزالة النتيجة القديمة من Google.',
    googleButton: 'إزالة النتيجة من Google',
    helpBadge: 'مساعدة اختيارية',
    helpTitle: 'لا تريد القيام بكل الخطوات وحدك؟',
    helpText: 'نراجع معك المواقع ونوضح لك ما يمكن حذفه أو إخفاؤه وكيف تكمل التحقق المطلوب. لا نعد بحذف كل نتيجة لأن بعض المواقع تفرض إجراءات تحقق خاصة بها.',
    helpPrice: '299 كرون مرة واحدة',
    helpButton: 'تواصل عبر WhatsApp',
    stickyText: 'مساعدة في حذف معلوماتك',
    stickyButton: 'WhatsApp',
  },
  sv: {
    seoTitle: 'Ta bort personuppgifter från svenska personsöksajter | StartaWebb',
    seoDescription: 'Officiella direktlänkar för att ta bort eller dölja uppgifter på Ratsit, Hitta, Eniro, MrKoll, Merinfo och Birthday, med valfri hjälp.',
    badge: 'Ta bort personuppgifter i Sverige',
    title: 'Ta bort dina personuppgifter från personsöksajter',
    intro: 'Du kan göra allt själv gratis via de officiella länkarna. Vill du ha hjälp går vi igenom tjänsterna med dig steg för steg.',
    freeBadge: 'Gratisalternativet',
    freeTitle: 'Gör det själv',
    freeText: 'Alla officiella länkar för borttagning och döljning är fortsatt gratis.',
    freeButton: 'Börja med gratislänkarna',
    paidBadge: 'Vill du ha hjälp?',
    paidTitle: 'Vi går igenom sajterna med dig',
    paidText: 'Vi hjälper dig se var uppgifter fortfarande syns och vilket nästa steg som gäller på varje tjänst.',
    paidButton: 'Få hjälp via WhatsApp',
    trustText: 'Vi ber aldrig om ditt BankID eller lösenord. Personlig verifiering gör du alltid själv.',
    includesTitle: 'Hjälpen omfattar',
    includes: ['Genomgång av de viktigaste tjänsterna', 'Rätt steg för varje tjänst', 'Kontroll av vad som fortfarande syns efteråt'],
    directTitle: 'Välj tjänst',
    directText: 'Använd den officiella länken gratis, eller be om hjälp med just den tjänsten.',
    methodBankId: 'BankID',
    removeStatus: 'Ta bort',
    hideStatus: 'Dölj',
    open: (name) => `Ta bort mina uppgifter från ${name}`,
    openHide: (name) => `Dölj mina uppgifter på ${name}`,
    helpService: (name) => `Hjälp mig med ${name}`,
    markDone: 'Klar',
    done: 'Klar ✓',
    details: 'Så gör du',
    guides: {
      ratsit: 'Öppna borttagningssidan, identifiera dig med BankID och följ instruktionerna till slutet.',
      hitta: 'Sök fram rätt kontaktsida, välj Ta bort och slutför verifieringen.',
      eniro: 'Sök efter ditt namn, logga in med BankID och ta bort eller dölj de uppgifter som går att hantera.',
      mrkoll: 'Logga in med BankID och dölj de uppgifter som MrKoll låter dig dölja.',
      merinfo: 'Öppna Merinfos borttagningssida, slutför verifieringen och bekräfta borttagningen.',
      birthday: 'Öppna Birthday i MinaUppgifter, verifiera dig med BankID och bekräfta borttagningen.',
    },
    warningTitle: 'Om ditt telefonnummer kommer tillbaka',
    warningText: 'Be din operatör att inte dela numret med katalogtjänster och kontrollera sedan sajterna igen när uppgifterna har uppdaterats.',
    googleTitle: 'Syns länken fortfarande i Google?',
    googleText: 'När sidan är borttagen från källan kan du begära att Google tar bort det gamla sökresultatet.',
    googleButton: 'Ta bort resultat från Google',
    helpBadge: 'Valfri hjälp',
    helpTitle: 'Vill du slippa göra hela genomgången ensam?',
    helpText: 'Vi går igenom sajterna med dig och visar vad som kan tas bort eller döljas och hur du slutför verifieringen. Vi lovar inte att varje resultat kan tas bort eftersom tjänsterna har egna regler.',
    helpPrice: '299 kr engångspris',
    helpButton: 'Kontakta oss på WhatsApp',
    stickyText: 'Hjälp med dina personuppgifter',
    stickyButton: 'WhatsApp',
  },
  en: {
    seoTitle: 'Remove personal data from Swedish people-search sites | StartaWebb',
    seoDescription: 'Official direct links to remove or hide your information from Ratsit, Hitta, Eniro, MrKoll, Merinfo and Birthday, with optional help.',
    badge: 'Remove personal data in Sweden',
    title: 'Remove your personal information from people-search sites',
    intro: 'You can complete the steps yourself for free using the official links. If you want help, we review the services with you step by step.',
    freeBadge: 'Free option',
    freeTitle: 'Do it yourself',
    freeText: 'All official removal and hiding links remain available for free.',
    freeButton: 'Start with the free links',
    paidBadge: 'Want help?',
    paidTitle: 'We review the sites with you',
    paidText: 'We help you identify where information is still visible and what the correct next step is on each service.',
    paidButton: 'Get help on WhatsApp',
    trustText: 'We never ask for your BankID or password. You always complete personal verification yourself.',
    includesTitle: 'Help includes',
    includes: ['Review of the main services', 'The correct step for each service', 'A check of what remains visible afterwards'],
    directTitle: 'Choose a service',
    directText: 'Use the official link for free, or ask for help with that specific service.',
    methodBankId: 'BankID',
    removeStatus: 'Remove',
    hideStatus: 'Hide',
    open: (name) => `Remove my information from ${name}`,
    openHide: (name) => `Hide my information on ${name}`,
    helpService: (name) => `Help me with ${name}`,
    markDone: 'Done',
    done: 'Done ✓',
    details: 'How to remove it',
    guides: {
      ratsit: 'Open the removal page, identify yourself with BankID and follow the instructions to completion.',
      hitta: 'Find the correct contact page, choose Ta bort and complete verification.',
      eniro: 'Search for your name, sign in with BankID and remove or hide the information available to manage.',
      mrkoll: 'Sign in with BankID and hide the information MrKoll allows you to hide.',
      merinfo: 'Open Merinfo’s removal page, complete verification and confirm removal.',
      birthday: 'Open Birthday in MinaUppgifter, verify with BankID and confirm removal.',
    },
    warningTitle: 'If your phone number appears again',
    warningText: 'Ask your operator not to share the number with directory services, then check the sites again after the data is updated.',
    googleTitle: 'Still visible in Google?',
    googleText: 'After the source page is removed, you can ask Google to remove the old search result.',
    googleButton: 'Remove result from Google',
    helpBadge: 'Optional help',
    helpTitle: 'Prefer not to handle the whole process alone?',
    helpText: 'We review the sites with you, explain what can be removed or hidden, and guide you through required verification. We cannot promise every result can be removed because each service has its own rules.',
    helpPrice: '299 SEK one-time',
    helpButton: 'Contact us on WhatsApp',
    stickyText: 'Help with your personal data',
    stickyButton: 'WhatsApp',
  },
  fr: {
    seoTitle: 'Supprimer vos données des annuaires suédois | StartaWebb',
    seoDescription: 'Liens officiels directs pour supprimer ou masquer vos données sur Ratsit, Hitta, Eniro, MrKoll, Merinfo et Birthday, avec aide facultative.',
    badge: 'Supprimer vos données personnelles en Suède',
    title: 'Supprimez vos informations personnelles des annuaires',
    intro: 'Vous pouvez effectuer les démarches vous-même gratuitement avec les liens officiels. Si vous souhaitez de l’aide, nous vérifions les services avec vous étape par étape.',
    freeBadge: 'Option gratuite',
    freeTitle: 'Faites-le vous-même',
    freeText: 'Tous les liens officiels de suppression et de masquage restent accessibles gratuitement.',
    freeButton: 'Commencer avec les liens gratuits',
    paidBadge: 'Besoin d’aide ?',
    paidTitle: 'Nous vérifions les sites avec vous',
    paidText: 'Nous vous aidons à voir où vos informations sont encore visibles et quelle étape suivre sur chaque service.',
    paidButton: 'Obtenir de l’aide sur WhatsApp',
    trustText: 'Nous ne demandons jamais votre BankID ni votre mot de passe. Vous effectuez toujours vous-même la vérification personnelle.',
    includesTitle: 'L’aide comprend',
    includes: ['Vérification des principaux services', 'La bonne démarche pour chaque service', 'Contrôle de ce qui reste visible ensuite'],
    directTitle: 'Choisissez un service',
    directText: 'Utilisez gratuitement le lien officiel ou demandez de l’aide pour ce service précis.',
    methodBankId: 'BankID',
    removeStatus: 'Supprimer',
    hideStatus: 'Masquer',
    open: (name) => `Supprimer mes informations de ${name}`,
    openHide: (name) => `Masquer mes informations sur ${name}`,
    helpService: (name) => `Aidez-moi avec ${name}`,
    markDone: 'Terminé',
    done: 'Terminé ✓',
    details: 'Comment faire',
    guides: {
      ratsit: 'Ouvrez la page de suppression, identifiez-vous avec BankID et suivez les instructions jusqu’à la fin.',
      hitta: 'Trouvez la bonne fiche, choisissez Ta bort puis terminez la vérification.',
      eniro: 'Recherchez votre nom, connectez-vous avec BankID puis supprimez ou masquez les informations disponibles.',
      mrkoll: 'Connectez-vous avec BankID puis masquez les informations que MrKoll permet de masquer.',
      merinfo: 'Ouvrez la page de suppression Merinfo, terminez la vérification puis confirmez la suppression.',
      birthday: 'Ouvrez Birthday dans MinaUppgifter, vérifiez-vous avec BankID puis confirmez la suppression.',
    },
    warningTitle: 'Si votre numéro de téléphone réapparaît',
    warningText: 'Demandez à votre opérateur de ne pas transmettre le numéro aux annuaires, puis vérifiez les sites à nouveau après la mise à jour.',
    googleTitle: 'Le lien apparaît encore dans Google ?',
    googleText: 'Après suppression de la page source, vous pouvez demander à Google de retirer l’ancien résultat.',
    googleButton: 'Supprimer le résultat de Google',
    helpBadge: 'Aide facultative',
    helpTitle: 'Vous préférez ne pas tout faire seul ?',
    helpText: 'Nous vérifions les sites avec vous, expliquons ce qui peut être supprimé ou masqué et vous guidons pour la vérification requise. Nous ne pouvons pas garantir que chaque résultat sera supprimé car chaque service a ses propres règles.',
    helpPrice: '299 SEK une fois',
    helpButton: 'Nous contacter sur WhatsApp',
    stickyText: 'Aide pour vos données personnelles',
    stickyButton: 'WhatsApp',
  },
};

function whatsappMessage(lang, service) {
  const serviceName = service || 'Ratsit, Hitta, Eniro, MrKoll, Merinfo och Birthday';
  const messages = {
    ar: service
      ? `مرحبا، أريد المساعدة في حذف أو إخفاء معلوماتي من ${serviceName}. رأيت خدمة المساعدة بسعر ${HELP_PRICE} كرون.`
      : `مرحبا، أريد المساعدة في مراجعة وحذف أو إخفاء معلوماتي من مواقع الأشخاص في السويد. رأيت خدمة المساعدة بسعر ${HELP_PRICE} كرون.`,
    sv: service
      ? `Hej, jag vill ha hjälp med att ta bort eller dölja mina uppgifter på ${serviceName}. Jag såg hjälpen för ${HELP_PRICE} kr.`
      : `Hej, jag vill ha hjälp att gå igenom och ta bort eller dölja mina uppgifter på svenska personsöktjänster. Jag såg hjälpen för ${HELP_PRICE} kr.`,
    en: service
      ? `Hello, I want help removing or hiding my information on ${serviceName}. I saw the help service for ${HELP_PRICE} SEK.`
      : `Hello, I want help reviewing and removing or hiding my information from Swedish people-search services. I saw the help service for ${HELP_PRICE} SEK.`,
    fr: service
      ? `Bonjour, je souhaite de l’aide pour supprimer ou masquer mes informations sur ${serviceName}. J’ai vu le service d’aide à ${HELP_PRICE} SEK.`
      : `Bonjour, je souhaite de l’aide pour vérifier et supprimer ou masquer mes informations sur les annuaires suédois. J’ai vu le service d’aide à ${HELP_PRICE} SEK.`,
  };
  return messages[lang] || messages.sv;
}

function paidHelpWhatsappUrl(lang, service) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage(lang, service))}`;
}

function trackHelpClick(lang, placement, service) {
  try {
    if (typeof window === 'undefined') return;
    const payload = {
      language: lang,
      placement,
      service: service || 'all',
      value: HELP_PRICE,
      currency: 'SEK',
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'privacy_paid_help_click', payload);
      window.gtag('event', 'generate_lead', payload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'privacy_paid_help_click', ...payload });
    window.dataLayer.push({ event: 'generate_lead', ...payload });
  } catch (error) {
    // Analytics must never block WhatsApp navigation.
  }
}

function HelpLink({ lang, t, placement, service, className, children }) {
  return (
    <a
      href={paidHelpWhatsappUrl(lang, service)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackHelpClick(lang, placement, service)}
      className={className}
    >
      {children || t.helpButton}
    </a>
  );
}

function ServiceCard({ source, t, lang, done, onToggle }) {
  const isHide = source.result === 'hide';
  const actionLabel = isHide ? t.openHide(source.name) : t.open(source.name);

  return (
    <article
      className={`flex h-full flex-col rounded-2xl border bg-white p-4 transition ${
        done
          ? 'border-emerald-300 shadow-sm'
          : 'border-slate-200 hover:border-sky-300 hover:shadow-sm'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-lg font-extrabold leading-tight text-slate-950 sm:text-xl">{source.name}</h3>
          <div className="mt-2 flex flex-wrap gap-1.5">
            <span className="rounded-full bg-sky-50 px-2.5 py-1 text-xs font-bold text-sky-800">{t.methodBankId}</span>
            <span
              className={`rounded-full px-2.5 py-1 text-xs font-bold ${
                isHide ? 'bg-amber-50 text-amber-800' : 'bg-emerald-50 text-emerald-800'
              }`}
            >
              {isHide ? t.hideStatus : t.removeStatus}
            </span>
          </div>
        </div>
        {done && (
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-sm font-extrabold text-emerald-700">
            ✓
          </span>
        )}
      </div>

      <details className="mt-3 border-t border-slate-100 pt-2.5">
        <summary className="cursor-pointer text-sm font-bold text-slate-700">{t.details}</summary>
        <p className="mt-2 text-sm leading-6 text-slate-600">{t.guides[source.key]}</p>
      </details>

      <div className="mt-auto space-y-2 pt-4">
        <a
          href={source.actionUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-11 w-full items-center justify-center rounded-xl bg-sky-700 px-3 py-2 text-center text-sm font-extrabold leading-5 text-white transition hover:bg-sky-800 focus:outline-none focus:ring-4 focus:ring-sky-100"
        >
          {actionLabel} ↗
        </a>

        <HelpLink
          lang={lang}
          t={t}
          placement="service_card"
          service={source.name}
          className="inline-flex min-h-11 w-full items-center justify-center rounded-xl border border-emerald-300 bg-emerald-50 px-3 py-2 text-center text-sm font-extrabold leading-5 text-emerald-800 transition hover:border-emerald-400 hover:bg-emerald-100 focus:outline-none focus:ring-4 focus:ring-emerald-100"
        >
          {t.helpService(source.name)}
        </HelpLink>

        <button
          type="button"
          aria-pressed={done}
          aria-label={done ? t.done : t.markDone}
          onClick={onToggle}
          className={`inline-flex min-h-10 w-full items-center justify-center rounded-xl border px-3 py-2 text-sm font-bold transition ${
            done
              ? 'border-emerald-300 bg-white text-emerald-800'
              : 'border-slate-300 bg-white text-slate-600 hover:border-emerald-300 hover:text-emerald-800'
          }`}
        >
          {done ? t.done : t.markDone}
        </button>
      </div>
    </article>
  );
}

export default function PrivacyRemovalRevenue({ language = 'sv' }) {
  const lang = COPY[language] ? language : 'sv';
  const t = COPY[lang];
  const meta = LANG[lang];
  const [completed, setCompleted] = useState({});
  const [progressLoaded, setProgressLoaded] = useState(false);

  const alternateUrls = Object.entries(ROUTES).map(([code, path]) => ({
    hrefLang: LANG[code].locale,
    url: `https://startawebb.se${path}`,
  }));

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(PROGRESS_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) setCompleted(parsed);
      }
    } catch (error) {
      // Progress is optional.
    } finally {
      setProgressLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (!progressLoaded) return;
    try {
      window.localStorage.setItem(PROGRESS_KEY, JSON.stringify(completed));
    } catch (error) {
      // Storage failures must not affect the guide.
    }
  }, [completed, progressLoaded]);

  const toggleDone = (key) => {
    setCompleted((current) => ({ ...current, [key]: !current[key] }));
  };

  return (
    <div dir={meta.dir} className="bg-slate-50 pb-24 text-slate-900 lg:pb-0">
      <SEOHead
        title={t.seoTitle}
        description={t.seoDescription}
        canonical={`https://startawebb.se${ROUTES[lang]}`}
        language={lang}
        locale={meta.locale.replace('-', '_')}
        direction={meta.dir}
        alternateUrls={alternateUrls}
      />

      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-8 lg:px-8 lg:py-10">
          <div className="max-w-4xl">
            <div className="mb-4 flex flex-wrap gap-2">
              {Object.entries(ROUTES).map(([code, path]) => (
                <Link
                  key={code}
                  to={path}
                  className={`rounded-lg border px-3 py-1.5 text-xs font-bold transition ${
                    code === lang
                      ? 'border-sky-700 bg-sky-700 text-white'
                      : 'border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:text-sky-800'
                  }`}
                >
                  {LANG[code].label}
                </Link>
              ))}
            </div>

            <p className="inline-flex rounded-full bg-sky-50 px-3 py-1 text-xs font-extrabold text-sky-800">{t.badge}</p>
            <h1 className="mt-3 text-3xl font-extrabold leading-tight tracking-tight text-slate-950 sm:text-4xl lg:text-5xl">{t.title}</h1>
            <p className="mt-3 max-w-3xl text-base leading-7 text-slate-600 sm:text-lg">{t.intro}</p>
          </div>

          <div className="mt-6 grid gap-3 lg:grid-cols-2">
            <div className="rounded-2xl border border-sky-200 bg-sky-50 p-4 sm:p-5">
              <p className="inline-flex rounded-full bg-white px-3 py-1 text-xs font-extrabold text-sky-800">{t.freeBadge}</p>
              <h2 className="mt-2 text-xl font-extrabold text-slate-950">{t.freeTitle}</h2>
              <p className="mt-2 text-sm leading-6 text-slate-700">{t.freeText}</p>
              <a
                href="#services"
                className="mt-4 inline-flex min-h-11 w-full items-center justify-center rounded-xl bg-sky-700 px-4 py-2.5 text-center text-sm font-extrabold text-white transition hover:bg-sky-800 sm:w-auto"
              >
                {t.freeButton}
              </a>
            </div>

            <div className="rounded-2xl border border-emerald-300 bg-emerald-50 p-4 shadow-sm sm:p-5">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <p className="inline-flex rounded-full bg-white px-3 py-1 text-xs font-extrabold text-emerald-800">{t.paidBadge}</p>
                <p className="text-sm font-extrabold text-emerald-800">{t.helpPrice}</p>
              </div>
              <h2 className="mt-2 text-xl font-extrabold text-slate-950">{t.paidTitle}</h2>
              <p className="mt-2 text-sm leading-6 text-slate-700">{t.paidText}</p>
              <HelpLink
                lang={lang}
                t={t}
                placement="hero"
                className="mt-4 inline-flex min-h-11 w-full items-center justify-center rounded-xl bg-emerald-700 px-4 py-2.5 text-center text-sm font-extrabold text-white transition hover:bg-emerald-800 sm:w-auto"
              >
                {t.paidButton}
              </HelpLink>
              <p className="mt-3 text-xs font-semibold leading-5 text-emerald-950/80">{t.trustText}</p>
            </div>
          </div>
        </div>
      </section>

      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-8 lg:px-8">
        <section className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5">
          <h2 className="text-lg font-extrabold text-slate-950">{t.includesTitle}</h2>
          <ul className="mt-3 grid gap-2 sm:grid-cols-3">
            {t.includes.map((item) => (
              <li key={item} className="flex items-start gap-2 text-sm leading-6 text-slate-700">
                <span aria-hidden="true" className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-xs font-black text-emerald-700">✓</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>

        <section id="services" className="scroll-mt-24 pt-7">
          <div className="max-w-3xl">
            <h2 className="text-2xl font-extrabold tracking-tight text-slate-950 sm:text-3xl">{t.directTitle}</h2>
            <p className="mt-1.5 text-sm leading-6 text-slate-600 sm:text-base">{t.directText}</p>
          </div>

          <div className="mt-5 grid items-stretch gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {SOURCES.map((source) => (
              <ServiceCard
                key={source.key}
                source={source}
                t={t}
                lang={lang}
                done={Boolean(completed[source.key])}
                onToggle={() => toggleDone(source.key)}
              />
            ))}
          </div>
        </section>

        <section className="mt-6 grid gap-3 lg:grid-cols-2">
          <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 sm:p-5">
            <h2 className="text-lg font-extrabold text-amber-950">{t.warningTitle}</h2>
            <p className="mt-2 text-sm leading-6 text-amber-900">{t.warningText}</p>
          </div>

          <div className="rounded-2xl border border-sky-200 bg-white p-4 sm:p-5">
            <h2 className="text-lg font-extrabold text-slate-950">{t.googleTitle}</h2>
            <p className="mt-2 text-sm leading-6 text-slate-600">{t.googleText}</p>
            <a
              href={GOOGLE_REMOVE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex min-h-10 w-full items-center justify-center rounded-xl bg-slate-900 px-4 py-2 text-center text-sm font-extrabold text-white transition hover:bg-slate-800 sm:w-auto"
            >
              {t.googleButton} ↗
            </a>
          </div>
        </section>

        <section className="mt-6 rounded-2xl border border-emerald-300 bg-emerald-50 p-4 shadow-sm sm:p-5">
          <div className="grid gap-4 lg:grid-cols-[1fr_auto] lg:items-center">
            <div>
              <div className="flex flex-wrap items-center gap-2">
                <p className="inline-flex rounded-full bg-white px-3 py-1 text-xs font-extrabold text-emerald-800">{t.helpBadge}</p>
                <p className="text-sm font-extrabold text-emerald-800">{t.helpPrice}</p>
              </div>
              <h2 className="mt-2 text-xl font-extrabold text-slate-950 sm:text-2xl">{t.helpTitle}</h2>
              <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-700">{t.helpText}</p>
              <p className="mt-2 text-xs font-semibold leading-5 text-emerald-950/80">{t.trustText}</p>
            </div>
            <HelpLink
              lang={lang}
              t={t}
              placement="bottom"
              className="inline-flex min-h-11 items-center justify-center rounded-xl bg-emerald-700 px-5 py-2.5 text-center text-sm font-extrabold text-white transition hover:bg-emerald-800"
            />
          </div>
        </section>
      </main>

      <div className="fixed inset-x-3 bottom-3 z-40 lg:hidden">
        <div className="mx-auto flex max-w-lg items-center gap-3 rounded-2xl border border-emerald-300 bg-white/95 p-2.5 shadow-xl backdrop-blur">
          <div className="min-w-0 flex-1 px-1">
            <p className="truncate text-xs font-bold text-slate-700">{t.stickyText}</p>
            <p className="text-sm font-extrabold text-emerald-800">{t.helpPrice}</p>
          </div>
          <HelpLink
            lang={lang}
            t={t}
            placement="sticky_mobile"
            className="inline-flex min-h-11 shrink-0 items-center justify-center rounded-xl bg-emerald-700 px-4 py-2 text-sm font-extrabold text-white transition hover:bg-emerald-800"
          >
            {t.stickyButton}
          </HelpLink>
        </div>
      </div>
    </div>
  );
}
